import React from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import MenuModalState from "../v2024/Login/modal-login-state"
import { ModalPricing } from "./modal-pricing"

export const Pricing = ({ index, item, formPricing, states, scrollToSection }) => {
    let loginModalState, requestDemoModalState, contactUsModalState
    states.map(state => {
        switch (state.form) {
            case 'demo': requestDemoModalState = state.state
                break
            case 'contact': contactUsModalState = state.state
                break
            case 'login': loginModalState = state.state
                break
        }
    })

    const pricingBasicModalState = MenuModalState()
    const pricingProModalState = MenuModalState()

    return (
        <div className={`pricing ${index === 1 ? "pricing__highlight" : ""}`}>
            <h1>{item.title}</h1>
            <div className="pricing__price">
                <h2>{item.price}</h2>
                <p>{item.price_detail}</p>
            </div>
            <div className="pricing__buttons">
                {item.buttons.map((button, key) => (
                    <>
                        {key === 0 ?
                            <div>
                                {button.url ?
                                    <button
                                        className={`button button--lg ${index !== 1 ? "button--secondary" : ""}`}
                                        onClick={() => loginModalState.openMenu()}>
                                        {button.text}
                                    </button>
                                    :
                                    button.text.includes("demo") ?
                                        <button
                                            className={`button button--lg ${index !== 1 ? "button--secondary" : ""}`}
                                            onClick={() => requestDemoModalState.openMenu()}>
                                            {button.text}
                                        </button>
                                        :
                                        <button
                                            className={`button button--lg ${index !== 1 ? "button--secondary" : ""}`}
                                            onClick={() => contactUsModalState.openMenu()}>
                                            {button.text}
                                        </button>
                                }
                            </div>
                            :
                            <div>
                                {index === 1 ?
                                    <a onClick={() => pricingBasicModalState.openMenu()}>
                                        {button.text}
                                    </a>
                                    :
                                    <a onClick={() => pricingProModalState.openMenu()}>
                                        {button.text}
                                    </a>
                                }
                            </div>
                        }
                    </>
                ))}
            </div>
            <ReactMarkdown children={item.description} rehypePlugins={[rehypeRaw]} />
            <div className="pricing__see-more">
                <a onClick={scrollToSection}>{item.see_more.text}</a>
            </div>
            {formPricing.map(form =>
                form.title === "Basic" ?
                    <ModalPricing
                        state={pricingBasicModalState}
                        form={form}
                    />
                    :
                    <ModalPricing
                        state={pricingProModalState}
                        form={form}
                    />
            )}
        </div>
    )
}